import { Theme } from "react-select";
import AsyncSelect from "react-select/async";

type AsyncSelectProps = React.ComponentProps<AsyncSelect>

export const customSelectStyles: AsyncSelectProps['styles'] = {
    control: (provided) => ({
        ...provided,
        boxShadow: '',
        backgroundColor: '',
        borderWidth: '',
        borderColor: '',
        borderRadius: '',
        color: '',
    }),
    input: (provided) => ({
        ...provided,
        margin: '',
        color: '',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '',
        color: '',
    }),
    indicatorSeparator: () => ({}),
    menu: (provided) => ({
        ...provided,
        boxShadow: '',
    }),
    menuList: () => ({}),
    option: () => ({}),
    placeholder: (provided) => ({
        ...provided,
        color: '',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'inherit',
    }),
};

export const customSelectTheme = (theme: Theme): Theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary: '#979797'
    },
});